import { CourseRole } from "../../shared/types/roles";

import { courseGroupingUserSelectors, createAppSelector } from "./base";
import { selectCurrentCourse } from "./current";

export const selectCourseGroupingUsersForCurrentCourse = createAppSelector(
  [courseGroupingUserSelectors.selectAll, selectCurrentCourse],
  (groupingUsers, course) =>
    groupingUsers.filter((gu) => gu.course_grouping_id === course?.grouping_id),
);

export const selectCurrentUserIsCourseGroupingAdminAnywhere = createAppSelector(
  [courseGroupingUserSelectors.filterForCurrentUser],
  (rows) => rows.some((r) => r.role === CourseRole.COURSE_ADMIN),
);
